
const Footer = () => {
  return (
    <footer className="bg-green-900 text-white">
      <div className="max-w-7xl mx-auto px-4 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Logo y descripción */}
          <div className="lg:col-span-2">
            <h3 className="text-4xl font-bold mb-4" style={{ fontFamily: 'Pacifico, serif' }}>
              Ecoffetours
            </h3>
            <p className="text-green-100 mb-4 leading-relaxed">
              Agencia de turismo especializada en ecoturismo sostenible en Mongua, Boyacá. 
              Conectamos a nuestros visitantes con la majestuosa naturaleza del páramo boyacense 
              a través de experiencias auténticas y responsables.
            </p>
            <p className="text-yellow-400 font-semibold text-lg" style={{ fontFamily: 'Pacifico, serif' }}>
              "Mongua, tierra del sol naciente"
            </p>
          </div>

          {/* Servicios */}
          <div>
            <h4 className="text-xl font-bold mb-6" style={{ fontFamily: 'Pacifico, serif' }}>
              Nuestros Servicios
            </h4>
            <ul className="space-y-3">
              <li>
                <a href="#" className="text-green-100 hover:text-white transition-colors duration-300 flex items-center">
                  <i className="ri-footprint-line mr-2"></i>
                  Senderismo Ecológico
                </a>
              </li>
              <li>
                <a href="#" className="text-green-100 hover:text-white transition-colors duration-300 flex items-center">
                  <i className="ri-camera-line mr-2"></i>
                  Avistamiento de Aves
                </a>
              </li>
              <li>
                <a href="#" className="text-green-100 hover:text-white transition-colors duration-300 flex items-center">
                  <i className="ri-tent-line mr-2"></i>
                  Camping Aventura
                </a>
              </li>
              <li>
                <a href="#" className="text-green-100 hover:text-white transition-colors duration-300 flex items-center">
                  <i className="ri-leaf-line mr-2"></i>
                  Tours Fotográficos
                </a>
              </li>
            </ul>
          </div>

          {/* Contacto */}
          <div>
            <h4 className="text-xl font-bold mb-6" style={{ fontFamily: 'Pacifico, serif' }}>
              Contacto
            </h4>
            <div className="space-y-3">
              <div className="flex items-start space-x-3">
                <i className="ri-map-pin-line text-green-300 mt-1"></i>
                <div>
                  <p className="text-green-100 text-sm">Calle 5 # 6 14</p>
                  <p className="text-green-100 text-sm">Mongua, Boyacá, Colombia</p>
                </div>
              </div>
              
              <div className="flex items-center space-x-3">
                <i className="ri-phone-line text-green-300"></i>
                <div>
                  <p className="text-green-100 text-sm">+57 310 254 7961</p>
                  <p className="text-green-100 text-sm">+57 311 890 3404</p>
                </div>
              </div>
              
              <div className="flex items-center space-x-3">
                <i className="ri-whatsapp-line text-green-300"></i>
                <p className="text-green-100 text-sm">+57 310 254 7961</p>
              </div>
              
              <div className="flex items-center space-x-3">
                <i className="ri-mail-line text-green-300"></i>
                <p className="text-green-100 text-sm">ecoffetours@gmail.com</p>
              </div>
              
              <div className="flex items-center space-x-3">
                <i className="ri-instagram-line text-green-300"></i>
                <p className="text-green-100 text-sm">@ecoffetours_agenciadeturismo</p>
              </div>
            </div>
          </div>
        </div>

        {/* Redes sociales */}
        <div className="border-t border-green-700 mt-12 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <div className="flex space-x-6 mb-4 md:mb-0">
              <a href="https://www.instagram.com/ecoffetours_agenciadeturismo" target="_blank" rel="nofollow" className="w-10 h-10 bg-green-700 hover:bg-green-600 rounded-full flex items-center justify-center transition-colors duration-300">
                <i className="ri-instagram-line text-lg"></i>
              </a>
              <a href="https://www.facebook.com/people/Ecoffetours/100063618908701" target="_blank" rel="nofollow" className="w-10 h-10 bg-green-700 hover:bg-green-600 rounded-full flex items-center justify-center transition-colors duration-300">
                <i className="ri-facebook-line text-lg"></i>
              </a>
              <a href="https://wa.me/573102547961" target="_blank" rel="nofollow" className="w-10 h-10 bg-green-700 hover:bg-green-600 rounded-full flex items-center justify-center transition-colors duration-300">
                <i className="ri-whatsapp-line text-lg"></i>
              </a>
            </div>
            
            <div className="text-center md:text-right">
              <p className="text-green-100 text-sm">
                © 2025 Ecoffetours. Todos los derechos reservados.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Schema.org FAQPage */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "FAQPage",
          "mainEntity": [
            {
              "@type": "Question",
              "name": "¿Qué servicios ofrece Ecoffetours?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Ofrecemos senderismo ecológico, avistamiento de aves, camping aventura y tours fotográficos en el páramo de Ocetá, Boyacá."
              }
            },
            {
              "@type": "Question", 
              "name": "¿Dónde está ubicada Ecoffetours?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Estamos ubicados en Calle 5 # 6 14, Mongua, Boyacá, Colombia. Mongua, tierra del sol naciente."
              }
            },
            {
              "@type": "Question",
              "name": "¿Cómo puedo contactar a Ecoffetours?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Puedes contactarnos al +57 310 254 7961, +57 311 890 3404, por email a ecoffetours@gmail.com o en Instagram @ecoffetours_agenciadeturismo."
              }
            }
          ]
        })}
      </script>
    </footer>
  );
};

export default Footer;
